import Verify from "pages/Auth/Verify/Verify"

const Email = () => {
    return (
        <Verify />
    )
}

export default Email
